/**
 * DatePicker 组件的 emit 事件声明
 * 基于方案设计文档生成
 */
export const emits = [
  /** visible 变化时触发（用于 v-model:visible） */
  'update:visible',
  /** 选中值变化时触发（Vue 3 v-model） */
  'update:modelValue',
  /** 选中值变化时触发（Vue 2 v-model） */
  'input',
  /** 点击确认按钮时触发 */
  'confirm',
  /** 点击关闭按钮或遮罩层关闭时触发 */
  'cancel',
  /** 选中项改变时触发（滚动停止后） */
  'change',
];
